<label class="option-label" [ccTooltip]="message ? { message } : undefined">
    {{label}}
</label>
<ng-content></ng-content>
